import '../util/scrollingSectionsSlider';

export default class imageOverlay {

  constructor() {
    this.heightHeader = $('header.banner').outerHeight(true);
    this.windowsHeight = $(window).height();
    this.windowsWhidth = $(window).width()
    this.breakPointToggle = 1739
    this.addEvents();
    this.buildNavigationBox();
    this.populateNavigationBox();
    this.getElementScrollable();
    this.checkResize();
    this.imageOverlayResize()
  }

  buildNavigationBox() {
    $('main.main').append('<span id="image-overlay-nav"> <span id="image-overlay-nav__toggle">Navigator</span> <ul id="image-overlay-nav__list"></ul></span>');
    $('.main-footer').addClass('footer-bottom-space');
  }

  //Check elemnts whit data-scroll attribute and build a list in the wrap
  populateNavigationBox() {
    $('[data-scroll]').each(function (index) {
      let scrollTarget = $(this).attr('data-scroll');
      if (index == 0) {
        $('<li to-scroll="' + scrollTarget + '" class="active">' + scrollTarget + '</li>').appendTo('#image-overlay-nav ul');
      } else {
        $('<li to-scroll="' + scrollTarget + '">' + scrollTarget + '</li>').appendTo('#image-overlay-nav ul');
      }
    });
  }


  addEvents() {
    let mythis = this;
    $(document).on('click', '#image-overlay-nav__toggle', function () {
      $('#image-overlay-nav__list').slideToggle();
    });


    $(document).on('click', '#image-overlay-nav li', function () {

      let breakPointToggle = mythis.breakPointToggle
      let windowsWhidth = mythis.windowsWhidth
      //Close box after click in small screen
      if (windowsWhidth <= breakPointToggle) {
        $('#image-overlay-nav__list').slideToggle();
      }

      //Scroll on the right section when i click on list item
      let targetAttribute = $(this).attr('to-scroll');
      let targetScroll = $('[data-scroll="' + targetAttribute + '"]')

      $('html, body').animate(
        {scrollTop: targetScroll.offset().top - mythis.heightHeader},
        500, 'linear')
    });

    //change color on the active item box when I scroll
    window.addEventListener('scroll', function () {
      let elementScrollable = mythis.getElementScrollable();
      let heightHeader = mythis.heightHeader

      $.each(elementScrollable, function (_index, value) {
        var element = value;
        let targetAttribute = element.attr('data-scroll');
        let elementHeight = element.outerHeight(true);
        let elementOffset = element.offset().top - $('header').offset().top - heightHeader

        if (elementOffset < heightHeader) {
          $('[to-scroll="' + targetAttribute + '"]').addClass('active')
        } else if (elementOffset < elementHeight) {
          $('[to-scroll="' + targetAttribute + '"]').removeClass('active')
        }
      });
    })

  }

  getElementScrollable() {
    var elementScrollable = [];
    $('[data-scroll]').each(function () {
      elementScrollable.push($(this));
    });
    return elementScrollable;
  }

  checkResize() {
    let myThis = this
    $(window).resize(function () {
      myThis.imageOverlayResize();
    });
    this.imageOverlayResize();
  }

  imageOverlayResize() {
    let imageOverlayHeight = $('.image-overlay__box').outerHeight(true);

    if (imageOverlayHeight >= this.windowsHeight) {
      $('.image-overlay').height('auto')
      $('.image-overlay__box').css({marginBottom: '100px'});
    } else {
      $('.image-overlay').css({height: '100vh'});
      $('.image-overlay__box').css({marginBottom: '0px'})
    }

    if (this.windowsWhidth > this.breakPointToggle) {
      $('#image-overlay-nav__list').show();
    } else {
      $('#image-overlay-nav__list').hide();
    }
  }

}

if($('.image-overlay').length) {
  new imageOverlay();
}



// WEBPACK FOOTER //
// ./scripts/gutenberg_components/_image-overlay.js